<div class="prop-content">
    <ag-grid-angular
        style="width: 100%; height: 100%;"
        [class]="(ThemeService.theme)? 'ag-theme-quartz-dark':'ag-theme-quartz'"
        [rowData]="rowData"
        [columnDefs]="columnDefs"
        [defaultColDef]="defaultColDef"
        [pinnedTopRowData]="pinnedTopRowData"
        [getRowStyle]="getRowStyle"
        (gridReady)="onGridReady($event)"
        [pagination]="true"
        [localeText]="ls.getCurrentGridLocale()"
        (cellEditingStopped)="onCellEditingStopped($event)"
        overlayNoRowsTemplate="Não encontrado nenhum resultado"
        >
    </ag-grid-angular>
</div>
